import { drawer_catalog } from './reports_dashboard_drawers';
import {
  decision_queue,
  decision_summary_cards,
  resolved_decisions,
  tabs
} from './reports_dashboard_decision_data';
import {
  board_packs,
  report_cards,
  scorecards
} from './reports_dashboard_content_data';
import {
  reports_dashboard_computed,
  reports_dashboard_methods
} from './reports_dashboard_ui';

export default {
  name: 'ComplyonReports',
  data: () => ({
    tabs,
    active_tab: 'decisions-required',
    drawer_catalog,
    decision_summary_cards,
    decision_queue,
    resolved_decisions,
    report_cards,
    board_packs,
    scorecards,
    active_drawer_key: null
  }),
  computed: reports_dashboard_computed,
  methods: reports_dashboard_methods
};
